import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  namespaced: true,

  state: {
    courses: [],
    subscriptions: [],
    loadingCourses: null,
    loadingSingleCourse: false,
    loadingCourseSubscription: null,
  },

  mutations,
  actions,
  getters,
};
